import React, { Component } from 'react';
import Portal from 'react-portal';
import { connect } from 'react-redux';
import { enableScroll, disableScroll } from '../../helpers/scroll';
import { setInfiniteScroll } from '../../actions/product';

import './style.css';

class Page extends Component {
  componentWillMount() {
    /* */
    setTimeout(() => {
      disableScroll();
      this.props.disableHeader();
    }, 500);
  }

  componentWillUnmount() {
    enableScroll();
    this.props.enableHeader();
  }

  render() {
    const { props } = this;
    const pageWrapperStyle = { ...props.style, overflow: 'hidden', background: props.background ? props.background : '#fff' };
    return (
      <Portal closeOnEsc={props.closeOnOutsideClick} closeOnOutsideClick={props.closeOnOutsideClick} isOpened={props.isOpened}>
        <div className="portal_wrapper">
          <div className="page_wrapper" style={pageWrapperStyle} onClick={this.props.onClose}>
            {props.children}
          </div>
        </div>
      </Portal>
    );
  }
}

const mapStateToProps = state => ({
  isMenuOpened: state.menu.isMenuOpened,
  bodyScrollTop: state.view.pos,
  router: state.router,
});

const mapDispatchToProps = dispatch => ({
  disableHeader: () => dispatch(setInfiniteScroll(false)),
  enableHeader: () => dispatch(setInfiniteScroll(true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page);



// WEBPACK FOOTER //
// ./src/components/Page/Page.jsx